module.exports = __webpack_public_path__ + "img/customers.a808f2df.svg";